import {Injectable} from "@angular/core";
import {ApiService} from "../../../shared/services/api/api.service";
import {IOrganization} from "../models/organization";
import {Observable} from "rxjs";
import {IPagination} from "../../../shared/services/api/interface/pagination.interface";


@Injectable({
  providedIn: 'root'
})

export class OrganizationService {

  constructor(private readonly apiService: ApiService) {
  }

  getList() {
    return this.apiService.get<any>('organization')
  }

  getListById(id: number | null) {
    return this.apiService.get<any[]>(`organization/recurrence-organizations/${id}`)
  }

  getById(id: number | null): Observable<any> {
    return this.apiService.get<any>(`organization/${id}`);
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`organization/organization-filter-list`, {
      event: event,
      filter: filter
    })
  }

  private fetchOrganizationFilter(
    url: string,
    event: any,
    filter: any
  ): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(url, {event, filter});
  }

  getOrganizationFilterByUser(event: any, filter: any): Observable<IPagination> {
    return this.fetchOrganizationFilter(
      `organization/organization-filter-list`,
      event,
      filter
    );
  }


  create(formData: FormData): Observable<IOrganization> {
    return this.apiService.post<any>('organization/create', formData)
  }

  update(formData: FormData): Observable<IOrganization> {
    return this.apiService.patch<any>('organization/update', formData);
  }

  delete(id: number): Observable<any> {
    return this.apiService.delete<any>(`organization/delete/${id}`)
  }

  updateVehicles(id: number | null, data: any): Observable<any> {
    return this.apiService.patch<any>(`organization/updateVehicles/${id}`, data);
  }
}
